import React from "react"
import types from "prop-types"
import { FormsyHiddenInput } from "shared/inputs"
import { snakeToCapitalCase } from "utils/stringHelpers"
import RequirementId from "./RequirementId"

const VIEW_UPLOAD_DOWNLOAD_ATTACHMENTS_KEY = "view_upload_download_submission_attachments"
const VIEW_UPLOAD_DOWNLOAD_ATTACHMENTS_LABEL = "View/Upload/Download Submission Attachments"

const formatLabel = (value) => {
  if (value === VIEW_UPLOAD_DOWNLOAD_ATTACHMENTS_KEY) {
    return VIEW_UPLOAD_DOWNLOAD_ATTACHMENTS_LABEL
  }
  return snakeToCapitalCase(value)
}

const RequirementAction = ({ id, index, value }) => (
  <div>
    <RequirementId index={index} value={id} />
    <FormsyHiddenInput
      name={`access_level_requirements_attributes[${index}].action`}
      value={value}
    />
    <span>{formatLabel(value)}</span>
  </div>
)

RequirementAction.propTypes = {
  id: types.number.isRequired,
  index: types.number.isRequired,
  value: types.string.isRequired,
}

export default RequirementAction
